import { PLACEMENT_DATA } from 'utils/constants/contacts';

export const addresses = [
  {
    title: 'In USA',
    text: PLACEMENT_DATA.USA,
  },
  {
    title: 'In Argentina',
    text: PLACEMENT_DATA.Argentina,
  },
  {
    title: 'Poland',
    text: PLACEMENT_DATA.Poland,
  },
];

export const addressesForContactUs = [
  addresses[0],
  addresses[2],
  addresses[1],
];
